import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsUsersMetricsQuery } from "../graphql/queries";
import type {
  AnalyticsUsersMetricsQueryType,
  AnalyticsUsersMetricsQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsUsersMetricsQuery = (
  options?: QueryHookOptions<
    AnalyticsUsersMetricsQueryType,
    AnalyticsUsersMetricsQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsUsersMetricsQueryType,
    AnalyticsUsersMetricsQueryVariablesType
  >(AnalyticsUsersMetricsQuery, options);
};
